// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";
import MKTypography from "components/MKTypography";
import cource1 from "assets/images/cource1.jpg";
import cource2 from "assets/images/2tankDive.jpg";
import cource3 from "assets/images/openwater.jpg";
import CardMedia from "@mui/material/CardMedia";
import Card from "@mui/material/Card";

function Information() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="body1" mt={-10} mb={0}>
              Try SCUBA is for people who do not have time to complete the open water course but
              would like to experience the underwater world. The first time you breathe underwater
              is an experience to remember and opens the door to whole new world. This could be
              achieved with our instructors who will go through some basic theory information and
              would hold you and guide you through a single dive. There is no doubt once you taken
              that plunge you’ll love it and the love for scuba could be described as an addiction.
              It would only seem right to continue to do your open water certification and explore
              the unexplored.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={5} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <Card sx={{ maxWidth: 500, borderRadius: 3, boxShadow: 3 }}>
              <CardMedia
                component="img"
                image={cource1}
                alt="Team Member"
                sx={{ height: 350, objectFit: "cover" }}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={15} alignItems="center">
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={cource2}
              height="300px"
              title="Sites up to 10KM away which includes the Pechora Breton (Colombo Cargo Wreck), Medhufaru Wreck, Nilgiri / Trug Wreck, Gale Reef, Barracuda Reef, Serendib Reef, Formosa"
              //description="Website visitors today demand a frictionless user expericence — especially when using search. Because of the hight standards."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Call Us",
              }}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={8} mb={0}>
              Two Tank Dives...
            </MKTypography>
            <MKTypography variant="body1" mt={4} mb={0}>
              Our Two Tank Dive is the ultimate way to experience the best of our local dive sites.
              Instead of returning to shore after one dive, you will enjoy two completely different
              underwater worlds in a single trip. The surface interval—a relaxing surface break
              where we serve refreshments and snacks—is spent cruising to a second, unique location.
              This package is perfect for certified divers looking to maximize their time on the
              water, see more marine life, and get the most value from their diving day.
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={8} mb={0}>
              Open Water Courses...
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              The Open water course is a step towards a recognized certified diver who is certified
              to dive with a buddy and without the supervision of a dive guide. It qualifies you to
              dive up to a maximum depth of 18meters. It would consist of three main sections the
              academics a pool session and four open water sessions. The academic will include going
              through a video on scuba diving and a dive manual that you could go through at your
              own pace. There after a pool training day for practicals to get you comfortable in the
              water. Finally you would go through four open water dives repeating the skills learned
              during your pool session. We take 4 to 5 days since we consider our happy customers as
              our future. We also give you to choose the days that are convenient for you and it
              does not have to be consecutive days how cool is that.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={cource3}
              height="300px"
              title="Your Passport to the Underwater World. Learn to Dive with Us."
              //description="Website visitors today demand a frictionless user expericence — especially when using search. Because of the hight standards."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Call Us",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
